import React, { useEffect, useState } from 'react';

// Requests
import { translateRequest } from '../../requests';

const useTranslate = defaultContent => {
  const [content, setContent] = useState(defaultContent);

  useEffect(() => {
    translateRequest(Object.values(content)).then(response =>
      setContent({
        ...Object.keys(content).reduce(
          (acc, curr, index) => ({ ...acc, [curr]: response[index] }),
          {}
        )
      })
    );
  }, []);

  return content;
};

export default useTranslate;
